import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskInspectionRunwayIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fill='currentColor'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19 19.4928L13.0885 17.6178V21.7464L14.5752 22.8822V24L11.9911 23.2608L9.42478 24V22.8822L10.8761 21.7464V17.6178L5 19.4928V18.0144L10.8761 14.2464V10.1178C10.8761 9.80529 10.9823 9.54087 11.1947 9.32452C11.4071 9.10817 11.6726 9 11.9911 9C12.3097 9 12.5723 9.10817 12.7788 9.32452C12.9853 9.54087 13.0885 9.80529 13.0885 10.1178V14.2464L19 18.0144V19.4928Z'
            />
            <Path fill='currentColor' d='M11.4 0.120117H12.6V3.34375H11.4V0.120117Z' />
            <Path fill='currentColor' d='M11.4 4.92017H12.6V8H11.4V4.92017Z' />
            <Path fill='currentColor' d='M21.5 0H23V23.76H21.5V0Z' />
            <Path fill='currentColor' d='M1 0H2.5V23.76H1V0Z' />
        </>
    ),
})

TaskInspectionRunwayIcon.displayName = 'TaskInspectionRunwayIcon'
